import { Setting2 } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Chip } from '@/components/Chip/Chip'
import { AppRoutes } from '@/constants/appRoutes'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'
import { textEllipsis } from '@/utils/strings'

import type { SidebarUserTypes } from './sidebarUser.types'

export const SidebarUser = ({
  userInitials,
  name,
  mail,
  isPending,
  profileImgUrl,
  isEarlyAdopter,
}: SidebarUserTypes) => {
  const { t } = useTranslation()
  return (
    <Link
      to={AppRoutes.account}
      role="button"
      className={`flex items-center justify-between p-2 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-2 border-y border-neutralColor5 bg-baseColor ${
        AppRoutes.account === location.pathname
          ? 'group-data-[collapsible=icon]:bg-neutralColor5'
          : 'group-data-[collapsible=icon]:hover:bg-baseColorHighlight'
      }`}
    >
      <div
        className={`flex flex-col gap-3 p-3 group-data-[collapsible=icon]:p-0 justify-between w-full rounded-xl ${
          AppRoutes.account === location.pathname
            ? 'bg-neutralColor5'
            : 'hover:bg-baseColorHighlight'
        }`}
      >
        <div className="flex items-center gap-2">
          <div className="flex justify-center items-center bg-baseColorHighlight border border-neutralColor30 rounded-full w-10 h-10 overflow-hidden flex-shrink-0 group-data-[collapsible=icon]:w-8 group-data-[collapsible=icon]:h-8">
            {profileImgUrl ? (
              <img
                src={profileImgUrl}
                alt="profile"
                className="w-full h-full object-cover"
              />
            ) : (
              <p className="text-lg text-textNormal font-medium tracking-tighter">
                {userInitials}
              </p>
            )}
          </div>

          <div className="flex flex-col justify-center min-w-0 flex-1 group-data-[collapsible=icon]:hidden">
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2">
                <p className="text-sm font-medium tracking-tight truncate text-textNormal">
                  {textEllipsis(name, 20)}
                </p>
              </div>

              {isPending && (
                <div className="bg-chipBackground py-1 px-2 rounded h-6 flex items-center justify-center flex-shrink-0">
                  <p className="text-xs tracking-wider font-medium">
                    {t('dashboard.reports.pending')}
                  </p>
                </div>
              )}
            </div>
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium tracking-tight truncate text-neutralColor60">
                {mail}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 group-data-[collapsible=icon]:hidden justify-end">
          {isEarlyAdopter && (
            <Chip
              text={t('dashboard.sidebar.vip')}
              variant="blue"
              size="tag"
              textStyle="w-full text-left "
              className="w-full"
            />
          )}
          <Setting2
            variant="Bold"
            size="20"
            color={SocialMirrorPalette.neutralColor}
          />
        </div>
      </div>
    </Link>
  )
}
